export enum Dialogs {
  PLAN_ACTIVITIES = 'PLAN_ACTIVITIES',
  FINISH_TOTURIALS = 'FINISH_TOTURIALS',
  REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS'
}
